import "../pages/communication/Report.css";

interface ReportFooterProps {
  page?: number;
}

const ReportFooter = ({ page }: ReportFooterProps) => {
  return (
    <footer className="pdf-footer">
      <div className="flex justify-end">
        <div className="text-black bg-primary px-4 rounded-full h-[42px] flex items-center">
          <span className="mb-4">{page}</span>
        </div>
      </div>
    </footer>
  );
};

export default ReportFooter;
